


































































































import Vue from "vue"
import http from './plugins/http';
import { Menu } from "./modules/Menu";
import * as Common from "./commons/common";


export type Datatype = {
  teacherSsoKey: string
}

export default Vue.extend({
  data(): Datatype {
    return {
      teacherSsoKey: "",
    }
  },
  computed: {
    userName(): string {
      if(this.$store.state.currentUser){
        const sufix = this.$store.state.currentUser.role == Common.RoleEnum.Student ? "さん" : "先生";
        return `${this.$store.state.currentUser.name}${sufix}`;
      }else{
        return "";
      }
    },
    isSignIn(): boolean {
      const path: string = this.$route.fullPath;
      return path === "/" || path.indexOf("sign_in") != -1 || path.indexOf("authorize") != -1 || path.indexOf("sign_out") != -1;
    },
    isSso(): boolean {
      const path: string = this.$route.fullPath;
      return path.indexOf("sso") != -1;
    },
    canShowTeacherSsoKey(): boolean {
      if(!this.$store.state.currentUser){
        return false;
      }

      const role = this.$store.state.currentUser.role;
      return [Common.RoleEnum.Admin, Common.RoleEnum.Teacher1, Common.RoleEnum.Teacher2].includes(role) && this.$store.getters.isOptionTeacherSsoActive;
    }
  },
  async created(): Promise<void> {
    this.$store.dispatch("hideOverlay");
    const inputs = document.getElementsByTagName("input");
    for(var i = 0; i < inputs.length; i++){
      inputs[0].setAttribute("autocomplete", "off");
    }
    await this.searchCurrentInfo();

    this.$bvModal.hide("msg-box");
    this.$store.commit("setIsShowingMsgBox", false);
  },
  methods: {
    to(menu: Menu): void {
      this.$router.push(menu.toUrl).catch((err: any) => {});
    },
    async searchCurrentInfo(): Promise<void> {
      if(this.isSignIn){
        await http.get("/api/version").then((response) =>{
          const version = response.data.version;
          const cookieVersion = Common.getCookieValue(document.cookie, "smarky_version");
          if(version != cookieVersion){
            document.cookie = 'smarky_version=' + version;
            if(!this.isSso){
              window.location.reload(true);
            }
            return;
          }
        });
        await http.get("/api/mainte_infos").then((response) =>{
          const mainteInfos = response.data;
          this.$store.commit("setMainteInfo", mainteInfos);
        });
      }else{
        await http.get("/api/current_user").then((response) =>{
          this.$store.commit("setCurrentUser", response.data.user);
          this.$store.commit("setSchools", response.data.schools);
          this.$store.commit("setMainteInfo", response.data.mainte_infos);
          this.$store.commit("setCourses", response.data.courses);
          this.$store.commit("setCampuses", response.data.campuses);
          this.$store.commit("setClassifications", response.data.classifications);
          this.$store.commit("setSubjects", response.data.subjects);
          this.$store.commit("setCurriculums", response.data.curriculums);
          this.$store.commit("setLessons", response.data.lessons);
        });
      }
    },
    logoClick(){
      if(this.$store.state.currentUser.role == Common.RoleEnum.Student){
        this.$router.push(`/${this.$store.state.school_url_prefix}/student_site/sheet_list`).catch((err: any) => {});
      }else{
        this.$store.dispatch("goSheetList");
      }
    },
    signOut(){
      this.$router.push("/sign_out").catch((err: any) => {});
    },
    async showTeacherSsoKeyModal(): Promise<void> {
      this.$store.dispatch("showOverlay");
      await http.get("/api/teacher/teacher_sso_key").then((response) =>{
        this.teacherSsoKey = response.data.teacher_sso_key;
        this.$bvModal.show("modal-teacher-sso-key");
      })
      .catch(error=>{
        if(error.response?.data?.errors){
          alert(error.response.data.errors[0]);
        }else{
          alert("SSOキーの取得に失敗しました。");
        }
      });
      this.$store.dispatch("hideOverlay");
    },
    async reissueTeacherSsoKey(): Promise<void> {
      if(!confirm("SSOキーを再発行します。外部システムに登録済みの旧SSOキーは使用できなくなります。よろしいですか？")){
        return;
      }

      this.$store.dispatch("showOverlay");
      await http.post("/api/teacher/teacher_sso_key/reissue").then((response) =>{
        this.teacherSsoKey = response.data.teacher_sso_key;
        alert("SSOキーを再発行しました。");
      })
      .catch(error=>{
        if(error.response?.data?.errors){
          alert(error.response.data.errors[0]);
        }else{
          alert("SSOキーの再発行に失敗しました。");
        }
      });
      this.$store.dispatch("hideOverlay");
    },
    async copyTeacherSsoKey(): Promise<void> {
      if(!this.teacherSsoKey){
        return;
      }

      try {
        if(navigator.clipboard){
          await navigator.clipboard.writeText(this.teacherSsoKey);
        }else{
          this.copyTextByTextarea(this.teacherSsoKey);
        }
        Common.showToast(this.$bvToast, "SSOキーをコピーしました。");
      } catch (e) {
        this.copyTextByTextarea(this.teacherSsoKey);
        Common.showToast(this.$bvToast, "SSOキーをコピーしました。");
      }
    },
    copyTextByTextarea(text: string): void {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "absolute";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    },
    // チャットの表示状態切り替え
    chatDipsChange(){
      const url = window.location.href;
      let isTeacherSignIn = url[url.length - 1] == "/" && url[url.length - 2] == "#";
      if(window.location.href.indexOf("student_site") == -1 && (window.location.href.indexOf("/sheet_list") != -1 || isTeacherSignIn)){
        // @ts-ignore
        window.zE('webWidget', 'show');
      }else{
        // @ts-ignore
        window.zE('webWidget', 'hide');
      }
    },
    // モバイル端末の場合の縮小設定
    setMetaViewport() {

      // デバイスのタイプをチェック
      let contentValue;
      if (this.$store.state.isTablet) {
        contentValue = "width=1550";
      } else {
        contentValue = "width=device-width,initial-scale=1.0";
      }

      // メタタグを作成
      let meta = document.createElement('meta');
      meta.name = "viewport";
      meta.content = contentValue;
        
      // 既存のメタタグがあれば削除
      const existingMeta = document.querySelector('meta[name="viewport"]');
      if (existingMeta) {
        document.head.removeChild(existingMeta);
      }

      // 新しいメタタグを追加
      document.head.appendChild(meta);

      // スマホの場合、テキストボックスのフォントサイズを変更
      if (this.$store.state.isPhone) {
        document.body.classList.add('is-mobile');
      }
    },
    schoolChanged() {
      http.post(`/api/teacher/sheet_list/update_admin_school/${this.$store.state.currentUser.school_id}`).then((response) =>{
        this.$store.commit("setCurrentUserSchoolOptions", response.data.school_options);
        window.location.reload();
      });
    }
  },
  watch: {
    async "$route" (toUrl: any, fromUrl: any){
      this.chatDipsChange();
      this.$store.commit("setIsShowingMsgBox", false);
      this.$store.dispatch("hideOverlay");
      const inputs = document.getElementsByTagName("input");
      for(var i = 0; i < inputs.length; i++){
        inputs[0].setAttribute("autocomplete", "off");
      }
      if(toUrl !== fromUrl){
        await this.searchCurrentInfo();
      }
    }
  },
  mounted(){
    this.setMetaViewport();
    this.chatDipsChange();
  }
});
